import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c6dc9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MModalSeletorRadio__Cabecalho" }
const _hoisted_2 = { class: "MModalSeletorRadio__Titulo" }
const _hoisted_3 = { class: "MModalSeletorRadio__Conteudo" }
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "MModalSeletorRadio__MensagemDeAlerta"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-exclamation-triangle" }, null, -1))
const _hoisted_7 = { class: "MModalSeletorRadio__Mensagem" }
const _hoisted_8 = { class: "MModalSeletorRadio__Rodape" }

import { computed, ref, watch } from "vue"
  import Dialog from "primevue/dialog"
  import RadioButton from "primevue/radiobutton"
  import AButton from "primevue/button"
  import { useI18n } from "vue-i18n"

  interface Props {
    teleportarPara?: string
    visibilidade: boolean
    tituloCabecalho: string
    estaCarregando?: boolean
    tipoDeAcao: "salvar" | "deletar"
    botoesRadio: Array<{ nome: string; chave: string }>
    mensagemDeAlerta?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MModalSeletorRadio',
  props: {
    teleportarPara: null,
    visibilidade: { type: Boolean },
    tituloCabecalho: null,
    estaCarregando: { type: Boolean, default: false },
    tipoDeAcao: { default: "deletar" },
    botoesRadio: null,
    mensagemDeAlerta: null
  },
  emits: ["aoAlterarVisibilidade", "aoAlterarOpcaoSelecionada", "aoClicarEmSubmeter"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "aoAlterarVisibilidade", visibilidade: boolean): void
    (event: "aoAlterarOpcaoSelecionada", opcaoSelecionada: string | null): void
    (event: "aoClicarEmSubmeter", opcaoSelecionada: string)
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { teleportarPara?: string, visibilidade: boolean, tituloCabecalho: string, estaCarregando: boolean, tipoDeAcao: "salvar" | "deletar", botoesRadio: Array<{ nome: string; chave: string }>, mensagemDeAlerta?: string }

  const opcaoSelecionada = ref<string | null>(null)

  

  

  const emitirVisibilidade = computed({
    get() {
      return props.visibilidade
    },
    set(visibilidade: boolean) {
      emitir("aoAlterarVisibilidade", visibilidade)
    },
  })

  const { t } = useI18n()

  const naoEscolheuNenhumaOpcao = computed(() => !opcaoSelecionada.value)

  const configuracaoBotaoSubmissor = computed(() => {
    const opcoesDeConfiguracao: {
      [key in Props["tipoDeAcao"]]: {
        descricao: string
        classe: string
      }
    } = {
      salvar: {
        descricao: t("salvar"),
        classe: "MModalSeletorRadio__BotaoSubmissor--salvar",
      },
      deletar: {
        descricao: t("deletar"),
        classe: "MModalSeletorRadio__BotaoSubmissor--deletar",
      },
    }

    return opcoesDeConfiguracao[props.tipoDeAcao]
  })

  const acaoBotaoSubmissor = (): void => {
    emitir("aoClicarEmSubmeter", opcaoSelecionada.value as string)
  }

  const acaoCancelar = (): void => {
    emitir("aoAlterarVisibilidade", false)
  }

  watch(opcaoSelecionada, () => {
    emitir("aoAlterarOpcaoSelecionada", opcaoSelecionada.value)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emitirVisibilidade),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(emitirVisibilidade) ? (emitirVisibilidade).value = $event : null)),
    "append-to": __props.teleportarPara,
    class: "MModalSeletorRadio",
    closable: "",
    "data-testid": "MModalSeletorRadio",
    draggable: false,
    header: "Header",
    modal: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.tituloCabecalho), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(AButton), {
          onClick: acaoCancelar,
          class: "MModalSeletorRadio__BotaoCancelar",
          "data-testid": "MModalSeletorRadio__BotaoCancelar",
          disabled: __props.estaCarregando,
          label: _unref(t)('cancelar')
        }, null, 8, ["disabled", "label"]),
        _createVNode(_unref(AButton), {
          onClick: acaoBotaoSubmissor,
          class: _normalizeClass(["MModalSeletorRadio__Botao MModalSeletorRadio__BotaoSubmissor", _unref(configuracaoBotaoSubmissor).classe]),
          "data-testid": "MModalSeletorRadio__BotaoSubmissor",
          disabled: _unref(naoEscolheuNenhumaOpcao) || __props.estaCarregando,
          label: _unref(configuracaoBotaoSubmissor).descricao,
          loading: __props.estaCarregando
        }, null, 8, ["class", "disabled", "label", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.botoesRadio, (botaoRadio) => {
          return (_openBlock(), _createElementBlock("div", {
            key: botaoRadio.chave,
            class: "MModalSeletorRadio__GrupoRadio"
          }, [
            _createVNode(_unref(RadioButton), {
              modelValue: opcaoSelecionada.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opcaoSelecionada).value = $event)),
              class: "MModalSeletorRadio__Radio",
              "data-testid": "MModalSeletorRadio__Radio",
              disabled: __props.estaCarregando,
              "input-id": botaoRadio.chave,
              name: botaoRadio.nome,
              value: botaoRadio.chave
            }, null, 8, ["modelValue", "disabled", "input-id", "name", "value"]),
            _createElementVNode("label", {
              class: "MModalSeletorRadio__DescricaoRadio",
              for: botaoRadio.chave
            }, _toDisplayString(botaoRadio.nome), 9, _hoisted_4)
          ]))
        }), 128)),
        (__props.mensagemDeAlerta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.mensagemDeAlerta), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "append-to"]))
}
}

})